


































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class TrashIcon extends Vue {
  @Prop({ default: '20' }) readonly width?: string;
  @Prop({ default: '20' }) readonly height?: string;
  @Prop({ default: '#E32B2E' }) readonly color?: string;
}
